import { selectSearchFilter } from '@services/utils';
import { Select } from 'antd';
import React from 'react';

const { Option } = Select;

const VersionSelect: React.FC<{
  versions?: Array<{ id: string; version: string; disabled?: boolean }>;
  deviceTypeId?: string;
  placeholder?: string;
  disabled?: boolean;
}> = ({ versions, deviceTypeId, disabled = false, ...props }) => (
  <Select allowClear showSearch filterOption={selectSearchFilter} disabled={disabled} {...props}>
    {deviceTypeId &&
      versions?.map((item) => (
        <Option key={item.id} value={item.id} disabled={item.disabled}>
          {item.version}
        </Option>
      ))}
  </Select>
);
export default VersionSelect;
